/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfContractListItemFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateContractCommand, type ComplianceItem, type ComplianceStatus, type CreateContractCommand, type PaginatedListOfContractListItem, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { AffiliatecodesRequestBuilderRequestsMetadata, type AffiliatecodesRequestBuilder } from './affiliatecodes/index.js';
// @ts-ignore
import { AffiliatesRequestBuilderNavigationMetadata, type AffiliatesRequestBuilder } from './affiliates/index.js';
// @ts-ignore
import { EligibilityRequestBuilderRequestsMetadata, type EligibilityRequestBuilder } from './eligibility/index.js';
// @ts-ignore
import { ContractItemRequestBuilderNavigationMetadata, ContractItemRequestBuilderRequestsMetadata, type ContractItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { MandatesRequestBuilderNavigationMetadata, type MandatesRequestBuilder } from './mandates/index.js';
// @ts-ignore
import { TodateRequestBuilderNavigationMetadata, TodateRequestBuilderRequestsMetadata, type TodateRequestBuilder } from './todate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts
 */
export interface ContractsRequestBuilder extends BaseRequestBuilder<ContractsRequestBuilder> {
    /**
     * The affiliatecodes property
     */
    get affiliatecodes(): AffiliatecodesRequestBuilder;
    /**
     * The affiliates property
     */
    get affiliates(): AffiliatesRequestBuilder;
    /**
     * The eligibility property
     */
    get eligibility(): EligibilityRequestBuilder;
    /**
     * The mandates property
     */
    get mandates(): MandatesRequestBuilder;
    /**
     * The todate property
     */
    get todate(): TodateRequestBuilder;
    /**
     * Gets an item from the ApiSdk.contracts.item collection
     * @param contractId Unique identifier of the item
     * @returns {ContractItemRequestBuilder}
     */
     byContractId(contractId: Guid) : ContractItemRequestBuilder;
    /**
     * GetContracts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfContractListItem>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ContractsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfContractListItem | undefined>;
    /**
     * CreateContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetContracts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ContractsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateContract
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateContractCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetContracts
 */
export interface ContractsRequestBuilderGetQueryParameters {
    item?: ComplianceItem;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
    status?: ComplianceStatus;
    year?: number;
}
/**
 * Uri template for the request builder.
 */
export const ContractsRequestBuilderUriTemplate = "{+baseurl}/contracts{?Item*,PageNumber*,PageSize*,SortExpression*,Status*,Year*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ContractsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "item": "Item",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
    "status": "Status",
    "year": "Year",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ContractsRequestBuilderNavigationMetadata: Record<Exclude<keyof ContractsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byContractId: {
        requestsMetadata: ContractItemRequestBuilderRequestsMetadata,
        navigationMetadata: ContractItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["contract%2Did"],
    },
    affiliatecodes: {
        requestsMetadata: AffiliatecodesRequestBuilderRequestsMetadata,
    },
    affiliates: {
        navigationMetadata: AffiliatesRequestBuilderNavigationMetadata,
    },
    eligibility: {
        requestsMetadata: EligibilityRequestBuilderRequestsMetadata,
    },
    mandates: {
        navigationMetadata: MandatesRequestBuilderNavigationMetadata,
    },
    todate: {
        requestsMetadata: TodateRequestBuilderRequestsMetadata,
        navigationMetadata: TodateRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ContractsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ContractsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfContractListItemFromDiscriminatorValue,
        queryParametersMapper: ContractsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: ContractsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateContractCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
